// extracted by mini-css-extract-plugin
export default {"introduction":"style_introduction__qj6F6"};